/** "Just now", "5m ago", "3d ago", "4mo ago", "2y ago". */
export function formatRelativeTime(value?: number | null, now = Date.now()): string {
  if (!value) return 'Never';
  const seconds = Math.max(0, Math.round((now - value) / 1000));
  if (seconds < 60) return 'Just now';
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.round(hours / 24);
  if (days < 30) return `${days}d ago`;
  if (days < 365) return `${Math.round(days / 30)}mo ago`;
  return `${Math.round(days / 365)}y ago`;
}
